"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[93166],{

/***/ 88737:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41120);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75154);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22318);



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var useStyles = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(theme) {
    var _obj;
    return (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        root: (_obj = {
            display: 'flex',
            flexWrap: 'wrap',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            minHeight: 70,
            padding: theme.spacing(4, 2),
            borderRadius: 6,
            background: theme.palette.primaryTransparent.light
        }, _defineProperty(_obj, theme.breakpoints.up('lg'), {
            flexDirection: 'row',
            justifyContent: 'space-between',
            textAlign: 'left',
            minHeight: 100,
            height: '100%',
            padding: theme.spacing(4, 4),
            borderRadius: theme.shape.borderRadius
        }), _defineProperty(_obj, '.MuiGrid-grid-md-4 &', {
            height: 'auto',
            padding: theme.spacing(1, 2),
            margin: theme.spacing(2, 0, 3)
        }), _obj),
        media: _defineProperty({
            margin: theme.spacing(0, 0, 2),
            '&>img': {
                display: 'block',
                maxWidth: 60
            }
        }, theme.breakpoints.up('lg'), {
            margin: 0,
            paddingRight: theme.spacing(5),
            '&>img': {
                maxWidth: 60
            }
        }),
        text: {
            flex: 1
        },
        richText: {
            '& p, & ul, & ol': {
                margin: 0
            },
            '& a': {
                color: 'currentColor',
                textDecoration: 'underline',
                '&:hover, &:focus': {
                    textDecoration: 'none'
                }
            }
        },
        rootCenter: _defineProperty({}, theme.breakpoints.up('lg'), {
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center'
        }),
        mediaCenter: {
            margin: theme.spacing(0, 0, 2),
            paddingRight: 0
        },
        commitmentImage: {
            width: '60px'
        }
    });
});
var Commitment = function(props) {
    var classes = useStyles(props);
    var icon = props.icon, title = props.title, desc = props.desc, center = props.center;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: center ? "commitment ".concat(classes.rootCenter, " ").concat(classes.root) : "commitment ".concat(classes.root),
        children: [
            icon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: center ? "commitment__media ".concat(classes.mediaCenter, " ").concat(classes.media) : "commitment__media ".concat(classes.media),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: icon,
                    alt: "",
                    className: classes.commitmentImage
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "commitment__text ".concat(classes.text),
                children: [
                    title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        variant: "h3",
                        component: "p",
                        className: 'commitment__title',
                        children: title
                    }),
                    desc && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        variant: "body1",
                        component: "div",
                        className: "commitment__desc ".concat(classes.richText),
                        children: desc
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Commitment);


/***/ }),

/***/ 75900:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41120);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75154);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Global_CMSText__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94455);




var useStyles = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(theme) {
    return (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        root: {
            display: 'block',
            height: 200,
            border: "1px solid ".concat(theme.palette.primary.main),
            textAlign: 'justify',
            overflowY: 'scroll',
            margin: theme.spacing(1),
            padding: theme.spacing(1)
        }
    });
});
var TextBox = function(param) {
    var text = param.text;
    var classes = useStyles();
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: text && text.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: classes.root,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Global_CMSText__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                data: text
            })
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (TextBox);


/***/ }),

/***/ 38269:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _home_ubuntu_build_wl_front_0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_ubuntu_build_wl_front_0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_ubuntu_build_wl_front_0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(41120);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(75154);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(73637);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(22318);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(41749);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _Button_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41107);
/* harmony import */ var _Commitment_Commitment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88737);
/* harmony import */ var _TextField_TextField__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59000);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36456);
/* harmony import */ var _redux_actions_user__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(76809);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(86010);
/* harmony import */ var _Loader_Loader__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96149);
/* harmony import */ var _Global_CMSText__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(94455);












function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var useStyles = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function(theme) {
    return (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({
        loginForm: {},
        loginFormCard: _defineProperty({
            padding: theme.spacing(3, 2, 2),
            background: theme.palette.common.white,
            borderRadius: theme.shape.borderRadius,
            margin: theme.spacing(0, 2)
        }, theme.breakpoints.up('sm'), {
            maxWidth: 400,
            margin: 'auto'
        }),
        loginFormCardFunnel: {
            padding: theme.spacing(2)
        },
        alignCenter: {
            textAlign: 'center'
        },
        form: {
            width: '70%',
            margin: 'auto'
        },
        link: {
            cursor: 'pointer',
            textDecoration: 'underline'
        },
        forgot: {
            textDecoration: 'underline',
            cursor: 'pointer'
        },
        alignLeft: {
            display: 'flex',
            justifyContent: 'flex-end',
            width: '100%'
        },
        marginBottom: {
            marginBottom: theme.spacing(2)
        },
        success: {
            color: theme.palette.success.main
        },
        hide: {
            opacity: 0,
            transition: theme.transitions.create('opacity')
        },
        show: {
            opacity: 1,
            transition: theme.transitions.create('opacity')
        }
    });
});
var mapStateToProps = function(state) {
    return {
        user: state.user
    };
};
var mapDispatchToProps = {
    forgetPassword: _redux_actions_user__WEBPACK_IMPORTED_MODULE_7__/* .forgetPassword */ .o9
};
var ForgotPasswordForm = function(param) {
    var isFunnel = param.isFunnel, text = param.text, switchForm = param.switchForm, forgetPassword1 = param.forgetPassword, t = param.t;
    var ref, ref1;
    var classes = useStyles();
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(''), email = ref2[0], setEmail = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), hasSend = ref3[0], setHasSend = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), error = ref4[0], setHasError = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isLoading = ref5[0], setIsLoading = ref5[1];
    var submitForm = function() {
        var _ref = _asyncToGenerator(_home_ubuntu_build_wl_front_0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(e) {
            var forgotReq;
            return _home_ubuntu_build_wl_front_0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        e.preventDefault();
                        setHasSend(false);
                        setHasError(false);
                        setIsLoading(true);
                        _ctx.next = 6;
                        return forgetPassword1(email);
                    case 6:
                        forgotReq = _ctx.sent;
                        if (forgotReq.type === 'FORGET_PASSWORD_FAILURE') {
                            setHasError(true);
                            setHasSend(false);
                            setIsLoading(false);
                        } else {
                            setHasSend(true);
                            setHasError(false);
                            setIsLoading(false);
                        }
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function submitForm(e) {
            return _ref.apply(this, arguments);
        };
    }();
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
        in: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
            className: !isFunnel ? "account-card forgot-card ".concat(classes.loginFormCard) : "account-form forgot-form ".concat(classes.loginForm),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                    variant: 'h3',
                    align: 'center',
                    className: "account__title ".concat(classes.marginBottom),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("b", {
                        children: (0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_9__/* .prismicText */ .yz)(text === null || text === void 0 ? void 0 : text.forget_title, t('texts:account:forget_title'))
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(isFunnel && classes.loginFormCardFunnel),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                            variant: 'body1',
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(classes.alignCenter, classes.marginBottom),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("b", {
                                children: (0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_9__/* .prismicText */ .yz)(text === null || text === void 0 ? void 0 : text.forget_subtitle, t('texts:account:forget_subtitle'))
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("form", {
                            onSubmit: submitForm,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(classes.form, classes.marginBottom),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                        container: true,
                                        spacing: 1,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                            item: true,
                                            sm: 12,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_TextField_TextField__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                type: 'email',
                                                name: 'email',
                                                required: true,
                                                label: (0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_9__/* .prismicText */ .yz)(text === null || text === void 0 ? void 0 : text.login_email, t('texts:account:email')),
                                                placeholder: (0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_9__/* .prismicText */ .yz)(text === null || text === void 0 ? void 0 : text.login_email, t('texts:account:email')),
                                                value: email,
                                                onChange: setEmail
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(classes.alignCenter, classes.marginBottom),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Button_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                        variant: 'contained',
                                        color: 'secondary',
                                        disabled: email === '' || isLoading,
                                        type: 'submit',
                                        className: 'account-forgot__btn',
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                className: isLoading ? classes.hide : classes.show,
                                                children: (0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_9__/* .prismicText */ .yz)(text === null || text === void 0 ? void 0 : text.button_recup, t('account:button_recup'))
                                            }),
                                            isLoading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Loader_Loader__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {})
                                        ]
                                    })
                                })
                            ]
                        }),
                        hasSend && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(classes.alignCenter, classes.marginBottom),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                variant: 'body2',
                                color: 'secondary',
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)('account__success', classes.success),
                                children: t('texts:account:email_send')
                            })
                        }),
                        error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(classes.alignCenter, classes.marginBottom),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                variant: 'body2',
                                color: 'error',
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)('account__error'),
                                children: t('texts:account:email_not_send')
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(classes.alignCenter, classes.marginBottom),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                variant: 'body2',
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)('account__back', classes.link),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                    onClick: function() {
                                        return switchForm(4);
                                    },
                                    children: (0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_9__/* .prismicText */ .yz)(text === null || text === void 0 ? void 0 : text.to_login_link, t('texts:account:to_login_link'))
                                })
                            })
                        }),
                        (text === null || text === void 0 ? void 0 : text.is_displayed_on_forgot_password_form) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Commitment_Commitment__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            icon: (text === null || text === void 0 ? void 0 : (ref = text.protected_data_image) === null || ref === void 0 ? void 0 : ref.url) ? text === null || text === void 0 ? void 0 : (ref1 = text.protected_data_image) === null || ref1 === void 0 ? void 0 : ref1.url : null,
                            title: (0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_9__/* .prismicText */ .yz)(text === null || text === void 0 ? void 0 : text.title_data, t('texts:account:title_data')),
                            desc: (0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_9__/* .prismicText */ .yz)(text === null || text === void 0 ? void 0 : text.text_data, t('texts:account:text_data')),
                            center: false
                        })
                    ]
                })
            ]
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,react_redux__WEBPACK_IMPORTED_MODULE_6__/* .connect */ .$j)(mapStateToProps, mapDispatchToProps)(ForgotPasswordForm));


/***/ }),

/***/ 90189:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ UserForm_LoginForm; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(41120);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/createStyles.js + 1 modules
var createStyles = __webpack_require__(75154);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Fade/Fade.js
var Fade = __webpack_require__(73637);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(41749);
// EXTERNAL MODULE: ./components/Button/Button.tsx
var Button = __webpack_require__(41107);
// EXTERNAL MODULE: ./components/Commitment/Commitment.tsx
var Commitment = __webpack_require__(88737);
// EXTERNAL MODULE: ./components/Loader/Loader.tsx
var Loader = __webpack_require__(96149);
// EXTERNAL MODULE: ./components/TextField/TextField.tsx + 1 modules
var TextField = __webpack_require__(59000);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/@datapunt/matomo-tracker-react/es/useMatomo.js + 1 modules
var useMatomo = __webpack_require__(86700);
// EXTERNAL MODULE: ./node_modules/react-google-recaptcha/lib/esm/index.js + 3 modules
var esm = __webpack_require__(34853);
// EXTERNAL MODULE: ./utils/constants.tsx
var constants = __webpack_require__(66026);
// EXTERNAL MODULE: ./components/Link/Link.tsx
var Link = __webpack_require__(31520);
// EXTERNAL MODULE: ./components/Global/CMSText.tsx
var CMSText = __webpack_require__(94455);
;// CONCATENATED MODULE: ./components/UserForm/SSOLink.tsx







var useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return (0,createStyles/* default */.Z)({
        alignCenter: {
            textAlign: 'center'
        },
        marginBottom: {
            marginBottom: theme.spacing(2)
        },
        hide: {
            opacity: 0,
            transition: theme.transitions.create('opacity')
        },
        show: {
            opacity: 1,
            transition: theme.transitions.create('opacity')
        }
    });
});
var SSOLink = function(param) {
    var isLoading = param.isLoading, defaultText = param.defaultText, data = param.data, linkSSO = param.linkSSO;
    var classes = useStyles();
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,clsx_m/* default */.Z)(classes.alignCenter, classes.marginBottom),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
            href: linkSSO,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    component: "span",
                    variant: 'contained',
                    color: 'secondary',
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: isLoading ? classes.hide : classes.show,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                            asText: true,
                            defaultText: defaultText,
                            data: data
                        })
                    })
                })
            })
        })
    }));
};
/* harmony default export */ var UserForm_SSOLink = (SSOLink);

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./components/UserForm/LoginForm.tsx
/* provided dependency */ var process = __webpack_require__(34155);














function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var recaptchaKey = process.env.RECAPTCHA_SITE_KEY;
var LoginForm_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return (0,createStyles/* default */.Z)({
        loginForm: {
            borderRadius: theme.shape.borderRadius,
            background: theme.palette.common.white,
            padding: theme.spacing(2),
            maxWidth: '100%',
            margin: theme.spacing(0, 2)
        },
        loginFormCard: _defineProperty({
            padding: theme.spacing(3, 2, 2)
        }, theme.breakpoints.up('sm'), {
            maxWidth: 400,
            margin: 'auto'
        }),
        loginFormCardFunnel: _defineProperty({}, theme.breakpoints.up('sm'), {
            maxWidth: 450,
            margin: 'auto'
        }),
        alignCenter: {
            textAlign: 'center'
        },
        form: {
            maxWidth: 300,
            margin: 'auto'
        },
        link: {
            cursor: 'pointer',
            //textDecoration: 'underline',
            marginBottom: theme.spacing(2)
        },
        forgot: {
            textDecoration: 'underline',
            cursor: 'pointer'
        },
        alignLeft: {
            display: 'flex',
            justifyContent: 'flex-end',
            width: '100%'
        },
        marginBottom: {
            marginBottom: theme.spacing(2)
        },
        hide: {
            opacity: 0,
            transition: theme.transitions.create('opacity')
        },
        show: {
            opacity: 1,
            transition: theme.transitions.create('opacity')
        },
        recaptcha: {
            display: 'flex',
            marginBottom: theme.spacing(2),
            justifyContent: 'center'
        }
    });
});
var ssoRedirectUrl = function(locale) {
    var onFunnel = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (false) {}
    var baseUrl = "https://test-experience.decathlon.com/";
    if (locale === 'fr') {
        return onFunnel ? "".concat(baseUrl, "shipping") : baseUrl;
    }
    return onFunnel ? "".concat(baseUrl).concat(locale, "/shipping") : "".concat(baseUrl).concat(locale);
};
var ssoClientKey = function(locale) {
    if (locale === 'fr') {
        return "30c03192-c348-42e8-9b4c-699e8efa26bd";
    }
    var keys = {
        fr: "30c03192-c348-42e8-9b4c-699e8efa26bd",
        de: "81d4de0f-80e9-4129-8c2f-2894d4e41c7e",
        es: "1293150a-2b32-434f-87ab-b2b693d5c6ed",
        it: "5bc2f882-0924-42d6-bbe5-6dc5480c103f"
    };
    return keys[locale.toLowerCase()] || "30c03192-c348-42e8-9b4c-699e8efa26bd";
};
var buildDecathlonSSOUrl = function(clientKey, redirectUrl) {
    return "".concat("https://api-global.decathlon.net/", "/connect/oauth/authorize?client_id=").concat(clientKey, "&response_type=code&redirect_uri=").concat(redirectUrl, "&state=decathlon&scope=profile email gender birthdate address shipping_address phone");
};
var buildCulturaSSOUrl = function(redirectUrl) {
    return "".concat("https://api-global.decathlon.net/", "authorize?client_id=").concat("30c03192-c348-42e8-9b4c-699e8efa26bd", "&response_type=code&scope=profile offline_access openid email address phone&redirect_uri=").concat(redirectUrl);
};
var LoginForm = function(param) {
    var hasRegistered = param.hasRegistered, loginError = param.loginError, switchForm = param.switchForm, errorAccountDisabled = param.errorAccountDisabled, isLoading = param.isLoading, submitLogin = param.submitLogin, t = param.t, isFunnel = param.isFunnel, text = param.text, takeBackTitle = param.takeBackTitle, _isTakeBack = param.isTakeBack, isTakeBack = _isTakeBack === void 0 ? false : _isTakeBack;
    var ref, ref1;
    var classes = LoginForm_useStyles();
    var ref2 = (0,react.useState)(''), email = ref2[0], setEmail = ref2[1];
    var ref3 = (0,react.useState)(''), password = ref3[0], setPassword = ref3[1];
    var trackEvent = (0,useMatomo/* default */.Z)().trackEvent;
    var ref4 = (0,react.useState)(!recaptchaKey ? true : false), captchaOK = ref4[0], setCaptchaOK = ref4[1];
    var recaptchaRef = /*#__PURE__*/ (0,react.createRef)();
    var router = (0,next_router.useRouter)();
    var currentLocale = router.locale;
    var isSubscription =  false || "date_to_date" === 'classic_subscription';
    var commitmentOnLogin = text === null || text === void 0 ? void 0 : text.is_displayed_on_login;
    var _ssoClientKey = ssoClientKey(currentLocale);
    var _ssoRedirectUrlOnFunnel = ssoRedirectUrl(currentLocale, true);
    var _ssoRedirectUrl = ssoRedirectUrl(currentLocale);
    var isSSOConfigured = !!( true && "https://test-experience.decathlon.com/shipping");
    var onReCAPTCHAChange = function(captchaCode) {
        if (!captchaCode) {
            return;
        } else {
            setCaptchaOK(true);
        }
    };
    var submitForm = function(e) {
        e.preventDefault();
        if (email !== '' && password !== '' && captchaOK) {
            var data = {
                email: email,
                password: password
            };
            submitLogin(data);
        }
        trackEvent({
            category: 'User Information',
            action: "User click on login button"
        });
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Fade/* default */.Z, {
        in: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: !isFunnel ? "account-card login-card ".concat(classes.loginForm, " ").concat(classes.loginFormCard) : "account-form login-form ".concat(classes.loginForm, " ").concat(classes.loginFormCardFunnel),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: !isSubscription ? 'dad' :  false ? 0 : 'csub',
                    "data-testid": 'guestUserBtn',
                    children: isFunnel && !isSubscription && (text === null || text === void 0 ? void 0 : text.is_display_guest_link) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,clsx_m/* default */.Z)(classes.alignCenter, classes.marginBottom),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            "data-testid": "guestNext",
                            variant: 'contained',
                            color: 'primary',
                            onClick: function() {
                                return switchForm(2);
                            },
                            className: (0,clsx_m/* default */.Z)(classes.link, 'login-form__button'),
                            children: (0,CMSText/* prismicText */.yz)(text === null || text === void 0 ? void 0 : text.guest_link, t('texts:account:guest_link'))
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: 'h3',
                    align: "center",
                    className: 'account__title',
                    gutterBottom: true,
                    children: (0,CMSText/* prismicText */.yz)(text === null || text === void 0 ? void 0 : text.title_login, t('texts:account:title_login'))
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        hasRegistered && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: 'body2',
                            color: 'secondary',
                            align: 'justify',
                            className: classes.marginBottom,
                            children: (0,CMSText/* prismicText */.yz)(text === null || text === void 0 ? void 0 : text.successfull_register, t('texts:account:successfull_register'))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                            variant: 'body1',
                            className: (0,clsx_m/* default */.Z)('account__desc', classes.alignCenter, classes.marginBottom),
                            children: [
                                !isTakeBack && /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                        asText: true,
                                        data: text === null || text === void 0 ? void 0 : text.subtitle,
                                        defaultText: t('texts:account:subtitle')
                                    })
                                }),
                                isTakeBack && takeBackTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                    asText: true,
                                    data: takeBackTitle,
                                    defaultText: t('texts:takeBack:login_text')
                                })
                            ]
                        }),
                        isSSOConfigured && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                 true && _ssoClientKey && _ssoRedirectUrlOnFunnel && _ssoRedirectUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)(UserForm_SSOLink, {
                                    isLoading: isLoading,
                                    defaultText: t('texts:account:sso_login:dkt'),
                                    data: text === null || text === void 0 ? void 0 : text.dkt_login,
                                    linkSSO: buildDecathlonSSOUrl(_ssoClientKey, isFunnel ? _ssoRedirectUrlOnFunnel : _ssoRedirectUrl)
                                }),
                                 false && /*#__PURE__*/ 0
                            ]
                        }),
                        process.env.CIAM_ENABLED && /*#__PURE__*/ (0,jsx_runtime.jsx)(UserForm_SSOLink, {
                            isLoading: isLoading,
                            defaultText: t('texts:account:sso_login:ciam'),
                            data: null,
                            linkSSO: "".concat(process.env.SSO_URL, "?redirect_path=").concat(isFunnel ? '/information' : '/account/informations')
                        }),
                        (!constants/* isSSO */.yf || constants/* isSSO */.yf && constants/* isLoginSSO */.H2 === 'false') && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                    onSubmit: submitForm,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (0,clsx_m/* default */.Z)('account__fields', 'account__hidden', classes.form, classes.marginBottom),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                                container: true,
                                                spacing: 1,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                        item: true,
                                                        xs: 12,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                                            label: (0,CMSText/* prismicText */.yz)(text === null || text === void 0 ? void 0 : text.login_email, t('texts:account:email')),
                                                            type: "email",
                                                            name: "email",
                                                            placeholder: t('texts:account:email'),
                                                            value: email,
                                                            required: true,
                                                            onChange: setEmail
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                        item: true,
                                                        xs: 12,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                                            label: (0,CMSText/* prismicText */.yz)(text === null || text === void 0 ? void 0 : text.login_password, t('texts:account:password')),
                                                            type: "password",
                                                            name: "password",
                                                            placeholder: t('texts:account:password'),
                                                            value: password,
                                                            required: true,
                                                            onChange: setPassword
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: classes.alignLeft,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                            variant: 'body2',
                                                            className: (0,clsx_m/* default */.Z)('account__forgot', classes.forgot),
                                                            onClick: function() {
                                                                return switchForm(5);
                                                            },
                                                            children: (0,CMSText/* prismicText */.yz)(text === null || text === void 0 ? void 0 : text.forget_password_link, t('texts:account:forget_password_link'))
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        recaptchaKey && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: classes.recaptcha,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* default */.Z, {
                                                ref: recaptchaRef,
                                                sitekey: recaptchaKey,
                                                onChange: onReCAPTCHAChange
                                            })
                                        }),
                                        loginError && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: 'body1',
                                            color: 'error',
                                            className: (0,clsx_m/* default */.Z)('account-login__error', classes.alignCenter, classes.marginBottom),
                                            children: (0,CMSText/* prismicText */.yz)(text === null || text === void 0 ? void 0 : text.error_login, t('texts:account:error_login'))
                                        }),
                                        errorAccountDisabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: 'body1',
                                            color: 'error',
                                            className: (0,clsx_m/* default */.Z)('account-login__error', classes.alignCenter, classes.marginBottom),
                                            children: (0,CMSText/* prismicText */.yz)(text === null || text === void 0 ? void 0 : text.error_account_disabled, t('texts:account:error_disabled'))
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (0,clsx_m/* default */.Z)(classes.alignCenter, classes.marginBottom, 'account-login__button'),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                                type: "submit",
                                                variant: 'contained',
                                                color: 'secondary',
                                                disabled: email === '' || password === '' || isLoading || !captchaOK,
                                                "data-testid": "nextConnected",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: isLoading ? classes.hide : classes.show,
                                                        children: (0,CMSText/* prismicText */.yz)(text === null || text === void 0 ? void 0 : text.login_button, t('texts:account:login_button'))
                                                    }),
                                                    isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* default */.Z, {})
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classes.alignCenter,
                                    children: constants/* disableRegister */.ZG ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: 'body2',
                                        children: t('texts:account:register_disable')
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: 'body2',
                                        onClick: function() {
                                            return switchForm(1);
                                        },
                                        "data-testid": 'register_link',
                                        className: (0,clsx_m/* default */.Z)('account__switch', classes.link),
                                        children: (0,CMSText/* prismicText */.yz)(text === null || text === void 0 ? void 0 : text.register_link, t('texts:account:register_link'))
                                    })
                                })
                            ]
                        }),
                        commitmentOnLogin && !isTakeBack && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: 'commitment__area',
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Commitment/* default */.Z, {
                                icon: (text === null || text === void 0 ? void 0 : (ref = text.protected_data_image) === null || ref === void 0 ? void 0 : ref.url) ? text === null || text === void 0 ? void 0 : (ref1 = text.protected_data_image) === null || ref1 === void 0 ? void 0 : ref1.url : null,
                                title: (0,CMSText/* prismicText */.yz)(text === null || text === void 0 ? void 0 : text.title_data, t('texts:account:title_data')),
                                desc: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                    data: text === null || text === void 0 ? void 0 : text.text_data,
                                    defaultText: t('texts:account:text_data')
                                }),
                                center: false
                            })
                        })
                    ]
                })
            ]
        })
    }));
};
/* harmony default export */ var UserForm_LoginForm = (LoginForm);


/***/ }),

/***/ 93748:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(41120);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(75154);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(73637);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(22318);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(41749);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(30553);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(80797);
/* harmony import */ var _Button_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41107);
/* harmony import */ var _Commitment_Commitment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88737);
/* harmony import */ var _Loader_Loader__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96149);
/* harmony import */ var _TextField_TextField__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59000);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(86010);
/* harmony import */ var _datapunt_matomo_tracker_react__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(86700);
/* harmony import */ var _TextField_TextBox__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(75900);
/* harmony import */ var react_google_recaptcha__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(34853);
/* harmony import */ var _Link_Link__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(31520);
/* harmony import */ var _Global_CMSText__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(94455);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(66026);
/* provided dependency */ var process = __webpack_require__(34155);















function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var recaptchaKey = process.env.RECAPTCHA_SITE_KEY;
var useStyles = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(function(theme) {
    return (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({
        root: {},
        registerFormCard: _defineProperty({
            background: theme.palette.common.white,
            padding: theme.spacing(2),
            borderRadius: theme.shape.borderRadius
        }, theme.breakpoints.up('sm'), {
            width: 600,
            margin: 'auto'
        }),
        formFooter: {
            textAlign: 'center'
        },
        link: {
            cursor: 'pointer',
            textDecoration: 'underline'
        },
        commitment: {
            maxWidth: 400,
            margin: 'auto'
        },
        marginBottom: {
            marginBottom: theme.spacing(2)
        },
        errorForm: {
            color: 'red'
        },
        hide: {
            opacity: 0,
            transition: theme.transitions.create('opacity')
        },
        show: {
            opacity: 1,
            transition: theme.transitions.create('opacity')
        },
        label: {
            display: 'block',
            cursor: 'pointer',
            fontSize: 9,
            paddingLeft: theme.spacing(1.25),
            marginBottom: theme.spacing(0.5)
        },
        checkbox: {
            '& .paragraph-class': {
                marginTop: 0,
                '&:last-child': {
                    marginBottom: 0
                }
            }
        },
        recaptcha: {
            display: 'flex',
            marginBottom: theme.spacing(2),
            justifyContent: 'center'
        },
        customCgl: {
            marginLeft: theme.spacing(4)
        },
        takeBackTitle: {
            textAlign: 'center'
        },
        selectContainer: {
            display: 'flex',
            flexDirection: 'column'
        },
        selectLabel: {
            display: 'block',
            cursor: 'pointer',
            textAlign: 'inherit',
            fontSize: 11,
            paddingLeft: theme.spacing(1.25),
            marginBottom: theme.spacing(0.5)
        },
        select: {
            display: 'block',
            padding: theme.spacing(1, 0.5),
            fontFamily: theme.typography.fontFamily,
            width: '100%',
            fontSize: 14,
            borderRadius: theme.shape.borderRadius,
            border: "1px solid ".concat(theme.extraColors.greyLight),
            color: theme.typography.body1.color,
            backgroundColor: theme.extraColors.greyLight
        }
    });
});
var RegisterForm = function(param) {
    var switchForm = param.switchForm, submitRegistration = param.submitRegistration, text = param.text, t = param.t, errorPhone = param.errorPhone, hasError = param.hasError, errorEmailUsed = param.errorEmailUsed, isLoading = param.isLoading, isFunnel = param.isFunnel, _isTakeBack = param.isTakeBack, isTakeBack = _isTakeBack === void 0 ? false : _isTakeBack, takeBackTitle = param.takeBackTitle, generalConfigData = param.generalConfigData;
    var ref22, ref1;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(_utils_constants__WEBPACK_IMPORTED_MODULE_10__/* .professionalAccountOnly */ .o5), isB2BAccount = ref2[0], setIsB2BAccount = ref2[1];
    var classes = useStyles();
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(''), firstName = ref3[0], setFirstName = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(''), name = ref4[0], setName = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(''), email = ref5[0], setEmail = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(''), phone = ref6[0], setPhone = ref6[1];
    var ref7 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(''), password = ref7[0], setPassword = ref7[1];
    var ref8 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(''), validPassword = ref8[0], setValidPassword = ref8[1];
    // B2B fields
    var ref9 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(''), siret = ref9[0], setSiret = ref9[1];
    var ref10 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(''), shopName = ref10[0], setShopName = ref10[1];
    // Brand customer fields
    var ref11 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isBrandCustomer = ref11[0], setIsBrandCustomer = ref11[1];
    var ref12 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(''), customerAccountId = ref12[0], setCustomerAccountId = ref12[1];
    // @todo: combine error logic and preferably use Formik or react-forms for form management
    var ref13 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), errorPassword = ref13[0], setErrorPassword = ref13[1];
    var ref14 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), errorEmail = ref14[0], setErrorEmail = ref14[1];
    var ref15 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), strongPasswordError = ref15[0], setStrongPasswordError = ref15[1];
    var ref16 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), errorSiret = ref16[0], setErrorSiret = ref16[1];
    var ref17 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), newsletter = ref17[0], setNewsLetter = ref17[1];
    var ref18 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), cgu = ref18[0], setCGU = ref18[1];
    var trackEvent = (0,_datapunt_matomo_tracker_react__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)().trackEvent;
    var commitmentOnRegister = text === null || text === void 0 ? void 0 : text.is_displayed_on_register;
    var bottomText = text === null || text === void 0 ? void 0 : text.register_bottom_text;
    var hasCGU = (0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_9__/* .isPrismicText */ .LT)(text === null || text === void 0 ? void 0 : text.cgu);
    var ref19 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(!recaptchaKey), captchaOK = ref19[0], setCaptchaOK = ref19[1];
    var recaptchaRef = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createRef)();
    var ref20 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(''), registeredStoreSlug = ref20[0], setRegisteredStoreSlug = ref20[1];
    var ref21 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)('m'), genderValue = ref21[0], setGenderValue = ref21[1];
    var handleGenderValue = function(event) {
        setGenderValue(event.target.value);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var ref;
        typeof localStorage !== 'undefined' && setRegisteredStoreSlug((ref = JSON.parse(localStorage.getItem('selectedStore'))) === null || ref === void 0 ? void 0 : ref.slug);
    }, []);
    var setEmailWithVerification = function(event) {
        var containsWhitespace = function containsWhitespace(str) {
            return /\s/.test(str);
        };
        setEmail(event);
        if (containsWhitespace(event)) {
            setErrorEmail(true);
        } else {
            setErrorEmail(false);
        }
    };
    var changeNewsletter = function() {
        setNewsLetter(!newsletter);
    };
    var changeCGU = function() {
        setCGU(!cgu);
    };
    var onReCAPTCHAChange = function(captchaCode) {
        if (!captchaCode) {
            return;
        } else {
            setCaptchaOK(true);
        }
    };
    var checkPassword = function(event) {
        setPassword(event);
        var regexStrongPassword = new RegExp('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{10,})');
        if (regexStrongPassword.test(event)) {
            setStrongPasswordError(false);
        } else {
            setStrongPasswordError(true);
        }
    };
    var submitForm = function(e) {
        e.preventDefault();
        if (isB2BAccount && (siret === '' || shopName === '')) {
            return;
        }
        if (password !== '' && firstName !== '' && name !== '' && email !== '' && captchaOK) {
            if (password === validPassword) {
                var data = _objectSpread({
                    gender: text.disable_gender ? 'u' : genderValue.trim(),
                    firstName: firstName.trim(),
                    lastName: name.trim(),
                    email: email.trim(),
                    phoneNumber: phone.trim(),
                    plainPassword: password,
                    subscribedToNewsletter: newsletter
                }, _utils_constants__WEBPACK_IMPORTED_MODULE_10__/* .isB2BRegistrationEnabled */ .Mk && isB2BAccount && {
                    siret: siret.trim(),
                    shopName: shopName.trim(),
                    isB2b: true
                }, _utils_constants__WEBPACK_IMPORTED_MODULE_10__/* .enableCustomerAccountId */ .ZO && _utils_constants__WEBPACK_IMPORTED_MODULE_10__/* .isB2BRegistrationEnabled */ .Mk && isB2BAccount && isBrandCustomer && {
                    isBrandCustomer: isBrandCustomer,
                    customerAccountId: customerAccountId.trim()
                });
                trackEvent({
                    category: 'User Information',
                    action: "User submit registration"
                });
                submitRegistration(data);
                setErrorPassword(false);
            } else {
                setErrorPassword(true);
            }
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        // If cgu are not filled in prismic, force cgu to true in order to create account
        if (!hasCGU) {
            setCGU(true);
        }
    }, [
        cgu
    ]);
    var triggerEvent = function() {
        trackEvent({
            category: 'User Information',
            action: "User is typing in email field on registration form"
        });
    };
    var setSiretWithValidation = function(value) {
        setSiret(value);
        // SIRET must be exactly 14 digits
        var siretRegex = /^\d{14}$/;
        if (value && !siretRegex.test(value.trim())) {
            setErrorSiret(true);
        } else {
            setErrorSiret(false);
        }
    };
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
        in: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
            className: !isFunnel ? "account-card register-card ".concat(classes.registerFormCard) : "account-form register-form ".concat(classes.root),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                    variant: 'h3',
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)('account__title', classes.marginBottom),
                    align: "center",
                    children: (0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_9__/* .prismicText */ .yz)(text === null || text === void 0 ? void 0 : text.title, t('texts:account:title'))
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                    variant: 'body1',
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)({
                        account__desc: isTakeBack
                    }),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                        children: !isTakeBack ? (0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_9__/* .prismicText */ .yz)(text === null || text === void 0 ? void 0 : text.login_title) : (0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_9__/* .prismicText */ .yz)(takeBackTitle, t('texts:takeBack:register_text'))
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                    variant: 'body2',
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)('account__desc', classes.marginBottom),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Global_CMSText__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                        data: text === null || text === void 0 ? void 0 : text.text,
                        defaultText: t('texts:account:text')
                    })
                }),
                _utils_constants__WEBPACK_IMPORTED_MODULE_10__/* .isB2BRegistrationEnabled */ .Mk && !_utils_constants__WEBPACK_IMPORTED_MODULE_10__/* .professionalAccountOnly */ .o5 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                    container: true,
                    spacing: 2,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                            item: true,
                            xs: 12,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                variant: "body2",
                                style: {
                                    fontWeight: 'bold'
                                },
                                children: t('texts:account:account_type') || 'Type de compte'
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                            item: true,
                            xs: 12,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                control: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                    checked: !isB2BAccount,
                                    onChange: function() {
                                        return setIsB2BAccount && setIsB2BAccount(false);
                                    },
                                    color: "primary"
                                }),
                                label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                    variant: "body2",
                                    children: t('texts:account:personal_account') || 'Compte particulier'
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                            item: true,
                            xs: 12,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                control: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                    checked: isB2BAccount,
                                    onChange: function() {
                                        return setIsB2BAccount && setIsB2BAccount(true);
                                    },
                                    color: "primary"
                                }),
                                label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                    variant: "body2",
                                    children: t('texts:account:b2b_account') || 'Compte professionnel (B2B)'
                                })
                            })
                        })
                    ]
                }),
                (!_utils_constants__WEBPACK_IMPORTED_MODULE_10__/* .isSSO */ .yf || _utils_constants__WEBPACK_IMPORTED_MODULE_10__/* .isSSO */ .yf && _utils_constants__WEBPACK_IMPORTED_MODULE_10__/* .isLoginSSO */ .H2 === 'false') && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                            container: true,
                            spacing: 1,
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)('account__fields', 'account__hidden', classes.marginBottom),
                            children: [
                                !text.disable_gender && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                    item: true,
                                    sm: 2,
                                    xs: 4,
                                    className: classes.selectContainer,
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(classes.selectLabel, 'label'),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Global_CMSText__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                                                asText: true,
                                                data: text === null || text === void 0 ? void 0 : text.gender_label,
                                                defaultText: t('texts:account:gender_label')
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("select", {
                                            value: genderValue,
                                            onChange: handleGenderValue,
                                            required: true,
                                            name: "title",
                                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(classes.select, 'select'),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                    value: 'm',
                                                    children: (0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_9__/* .prismicText */ .yz)(text === null || text === void 0 ? void 0 : text.gender_male, t('texts:account:gender_male'))
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                    value: 'f',
                                                    children: (0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_9__/* .prismicText */ .yz)(text === null || text === void 0 ? void 0 : text.gender_female, t('texts:account:gender_female'))
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                    item: true,
                                    sm: text.disable_gender ? 6 : 5,
                                    xs: 12,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_TextField_TextField__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                        label: (0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_9__/* .prismicText */ .yz)(text === null || text === void 0 ? void 0 : text.firstname, t('texts:account:firstname')),
                                        type: "text",
                                        name: "firstName",
                                        placeholder: (0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_9__/* .prismicText */ .yz)(text === null || text === void 0 ? void 0 : text.firstname, t('texts:account:firstname')),
                                        value: firstName,
                                        required: true,
                                        onChange: setFirstName
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                    item: true,
                                    sm: text.disable_gender ? 6 : 5,
                                    xs: 12,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_TextField_TextField__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                        label: (0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_9__/* .prismicText */ .yz)(text === null || text === void 0 ? void 0 : text.lastname, t('texts:account:lastname')),
                                        type: "text",
                                        name: "lastName",
                                        placeholder: (0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_9__/* .prismicText */ .yz)(text === null || text === void 0 ? void 0 : text.lastname, t('texts:account:lastname')),
                                        value: name,
                                        required: true,
                                        onChange: setName
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                    item: true,
                                    sm: 6,
                                    xs: 12,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_TextField_TextField__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                        label: (0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_9__/* .prismicText */ .yz)(text === null || text === void 0 ? void 0 : text.email, t('texts:account:email')),
                                        type: "text",
                                        name: "email",
                                        placeholder: (0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_9__/* .prismicText */ .yz)(text === null || text === void 0 ? void 0 : text.email, t('texts:account:email')),
                                        value: email,
                                        required: true,
                                        onChange: setEmailWithVerification,
                                        onClick: triggerEvent
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                    item: true,
                                    sm: 6,
                                    xs: 12,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_TextField_TextField__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                        label: (0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_9__/* .prismicText */ .yz)(text === null || text === void 0 ? void 0 : text.phone, t('texts:account:phone')),
                                        type: "text",
                                        name: "phone",
                                        placeholder: (0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_9__/* .prismicText */ .yz)(text === null || text === void 0 ? void 0 : text.phone, t('texts:account:phone')),
                                        value: phone,
                                        required: true,
                                        onChange: setPhone,
                                        phoneInputInfosIcon: {
                                            tooltipTitle: generalConfigData === null || generalConfigData === void 0 ? void 0 : generalConfigData.phone_input_infos
                                        }
                                    })
                                }),
                                _utils_constants__WEBPACK_IMPORTED_MODULE_10__/* .isB2BRegistrationEnabled */ .Mk && isB2BAccount && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                            item: true,
                                            sm: 6,
                                            xs: 12,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_TextField_TextField__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                label: t('texts:account:siret') || 'SIRET',
                                                type: "text",
                                                name: "siret",
                                                placeholder: t('texts:account:siret') || 'SIRET',
                                                value: siret,
                                                required: true,
                                                onChange: setSiretWithValidation,
                                                className: errorSiret && classes.errorForm
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                            item: true,
                                            sm: 6,
                                            xs: 12,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_TextField_TextField__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                label: t('texts:account:company_name') || 'Nom de la soci\xe9t\xe9',
                                                type: "text",
                                                name: "shopName",
                                                placeholder: t('texts:account:company_name') || 'Nom de la soci\xe9t\xe9',
                                                value: shopName,
                                                required: true,
                                                onChange: setShopName
                                            })
                                        })
                                    ]
                                }),
                                _utils_constants__WEBPACK_IMPORTED_MODULE_10__/* .enableCustomerAccountId */ .ZO && _utils_constants__WEBPACK_IMPORTED_MODULE_10__/* .isB2BRegistrationEnabled */ .Mk && isB2BAccount && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                            item: true,
                                            xs: 12,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                                className: classes.checkbox,
                                                control: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                                    checked: isBrandCustomer,
                                                    onChange: function() {
                                                        return setIsBrandCustomer(!isBrandCustomer);
                                                    },
                                                    name: "isBrandCustomer"
                                                }),
                                                label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                                    variant: 'body2',
                                                    children: (0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_9__/* .prismicText */ .yz)(text === null || text === void 0 ? void 0 : text.is_customer, t('texts:account:is_customer'))
                                                })
                                            })
                                        }),
                                        isBrandCustomer && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                            item: true,
                                            xs: 12,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_TextField_TextField__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                label: (0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_9__/* .prismicText */ .yz)(text === null || text === void 0 ? void 0 : text.customer_account_id, t('texts:account:customer_account_id')),
                                                type: "text",
                                                name: "customerAccountId",
                                                placeholder: t('texts:account:customer_account_id'),
                                                value: customerAccountId,
                                                onChange: setCustomerAccountId
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                    item: true,
                                    sm: 6,
                                    xs: 12,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_TextField_TextField__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                        label: (0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_9__/* .prismicText */ .yz)(text === null || text === void 0 ? void 0 : text.password, t('texts:account:password')),
                                        type: "password",
                                        name: "password",
                                        placeholder: (0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_9__/* .prismicText */ .yz)(text === null || text === void 0 ? void 0 : text.password, t('texts:account:password')),
                                        value: password,
                                        required: true,
                                        className: errorPassword && classes.errorForm,
                                        onChange: checkPassword
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                    item: true,
                                    sm: 6,
                                    xs: 12,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_TextField_TextField__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                        label: (0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_9__/* .prismicText */ .yz)(text === null || text === void 0 ? void 0 : text.repeat_password, t('texts:account:repeat_password')),
                                        type: "password",
                                        name: "validPassword",
                                        className: errorPassword && classes.errorForm,
                                        placeholder: (0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_9__/* .prismicText */ .yz)(text === null || text === void 0 ? void 0 : text.repeat_password, t('texts:account:repeat_password')),
                                        value: validPassword,
                                        required: true,
                                        onChange: setValidPassword
                                    })
                                }),
                                (0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_9__/* .isPrismicText */ .LT)(text === null || text === void 0 ? void 0 : text.newsletter) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                    item: true,
                                    xs: 12,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                        className: classes.checkbox,
                                        control: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                            checked: newsletter,
                                            onChange: changeNewsletter,
                                            name: "checkedA"
                                        }),
                                        label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                            variant: 'body2',
                                            component: 'div',
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Global_CMSText__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                                                data: text === null || text === void 0 ? void 0 : text.newsletter,
                                                defaultText: t('texts:account:newsletter')
                                            })
                                        })
                                    })
                                }),
                                hasCGU && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                                    item: true,
                                    xs: 12,
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                            className: classes.checkbox,
                                            control: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                                checked: cgu,
                                                onChange: changeCGU,
                                                name: "cgu_agree",
                                                "data-testid": 'cgu_agree'
                                            }),
                                            label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                                variant: 'body2',
                                                component: 'div',
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Global_CMSText__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                                                    data: text === null || text === void 0 ? void 0 : text.cgu
                                                })
                                            })
                                        }),
                                        registeredStoreSlug && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                            variant: 'body2',
                                            component: 'span',
                                            className: classes.customCgl,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Link_Link__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                                href: "/pages/cgl-".concat(registeredStoreSlug),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Global_CMSText__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                                                        data: text === null || text === void 0 ? void 0 : text.custom_cgu_link,
                                                        asText: true,
                                                        defaultText: t('texts:funnel:payment:custom_cgu_link')
                                                    })
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(classes.formFooter, classes.marginBottom),
                            children: [
                                errorPassword && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                    variant: 'body2',
                                    color: 'error',
                                    className: classes.marginBottom,
                                    children: (0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_9__/* .prismicText */ .yz)(text === null || text === void 0 ? void 0 : text.password_error, t('texts:account:password_error'))
                                }),
                                strongPasswordError && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                    variant: 'body2',
                                    color: 'error',
                                    className: classes.marginBottom,
                                    children: (0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_9__/* .prismicText */ .yz)(text === null || text === void 0 ? void 0 : text.password_strength_error, t('texts:account:password_strength_error'))
                                }),
                                hasError && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                    variant: 'body2',
                                    color: 'error',
                                    className: classes.marginBottom,
                                    children: (0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_9__/* .prismicText */ .yz)(text === null || text === void 0 ? void 0 : text.error_happend, t('texts:account:error_happend'))
                                }),
                                errorEmailUsed && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                    variant: 'body2',
                                    color: 'error',
                                    className: classes.marginBottom,
                                    children: (0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_9__/* .prismicText */ .yz)(text === null || text === void 0 ? void 0 : text.email_error, t('texts:account:mail_used'))
                                }),
                                errorEmail && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                    variant: 'body2',
                                    color: 'error',
                                    className: classes.marginBottom,
                                    children: (0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_9__/* .prismicText */ .yz)(text === null || text === void 0 ? void 0 : text.email_format_incorrect, t('texts:account:email_format_incorrect'))
                                }),
                                errorPhone && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                    variant: 'body2',
                                    color: 'error',
                                    align: 'center',
                                    className: classes.marginBottom,
                                    children: (0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_9__/* .prismicText */ .yz)(text === null || text === void 0 ? void 0 : text.error_phone, t('texts:account:error_phone'))
                                }),
                                errorSiret && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                    variant: 'body2',
                                    color: 'error',
                                    align: 'center',
                                    className: classes.marginBottom,
                                    children: t('texts:account:error_siret') || 'Le SIRET doit contenir exactement 14 chiffres'
                                }),
                                (0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_9__/* .isPrismicText */ .LT)(bottomText) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                    variant: 'body2',
                                    component: 'div',
                                    className: 'account__bottom-text',
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Global_CMSText__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                                        data: bottomText
                                    })
                                }),
                                recaptchaKey && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: classes.recaptcha,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_google_recaptcha__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                        ref: recaptchaRef,
                                        sitekey: recaptchaKey,
                                        onChange: onReCAPTCHAChange
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Button_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    variant: 'contained',
                                    color: 'secondary',
                                    type: 'submit',
                                    "data-testid": 'registrationButton',
                                    className: 'register--validation__btn',
                                    onClick: submitForm,
                                    disabled: firstName === '' || name === '' || email === '' || phone === '' || phone === undefined || password === '' || validPassword === '' || !cgu || !captchaOK || strongPasswordError || _utils_constants__WEBPACK_IMPORTED_MODULE_10__/* .isB2BRegistrationEnabled */ .Mk && isB2BAccount && (siret === '' || shopName === '' || errorSiret) || _utils_constants__WEBPACK_IMPORTED_MODULE_10__/* .enableCustomerAccountId */ .ZO && isB2BAccount && _utils_constants__WEBPACK_IMPORTED_MODULE_10__/* .isB2BRegistrationEnabled */ .Mk && isBrandCustomer && customerAccountId === '',
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: isLoading ? classes.hide : classes.show,
                                            children: (0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_9__/* .prismicText */ .yz)(text === null || text === void 0 ? void 0 : text.register_button, t('texts:account:register_button'))
                                        }),
                                        isLoading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Loader_Loader__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {})
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(classes.formFooter, classes.marginBottom),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                variant: 'body2',
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)('account__switch', classes.link),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    onClick: function() {
                                        return switchForm(4);
                                    },
                                    "data-testid": 'toLogin',
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Global_CMSText__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                                        asText: true,
                                        data: text === null || text === void 0 ? void 0 : text.login_link,
                                        defaultText: t('texts:account:login_link')
                                    })
                                })
                            })
                        })
                    ]
                }),
                commitmentOnRegister && !isTakeBack ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(classes.commitment, 'commitment__area'),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Commitment_Commitment__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        icon: (text === null || text === void 0 ? void 0 : (ref22 = text.protected_data_image) === null || ref22 === void 0 ? void 0 : ref22.url) ? text === null || text === void 0 ? void 0 : (ref1 = text.protected_data_image) === null || ref1 === void 0 ? void 0 : ref1.url : null,
                        title: (0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_9__/* .prismicText */ .yz)(text === null || text === void 0 ? void 0 : text.title_data, t('texts:account:title_data')),
                        desc: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Global_CMSText__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                            data: text === null || text === void 0 ? void 0 : text.text_data,
                            defaultText: t('texts:account:text_data')
                        }),
                        center: false
                    })
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                    variant: 'caption',
                    component: 'div',
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Global_CMSText__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                        data: text === null || text === void 0 ? void 0 : text.alternative_text_for_register
                    })
                }),
                (text === null || text === void 0 ? void 0 : text.is_display_text_box) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_TextField_TextBox__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    text: text === null || text === void 0 ? void 0 : text.data_text
                })
            ]
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (RegisterForm);


/***/ })

}]);